import { autoinject, transient } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/power-bi/power-bi.constants";
import { EmbedParams } from "../../models/power-bi/power-bi.models";

@autoinject()
@transient()
export class PowerBiService {
    
    constructor(private requestClient: RequestClientService) { }

    public getEmbedInfo(reportId: number, entityTypeId: number, entityId: number): Promise<EmbedParams> {
        return this.requestClient.get(Urls.GetEmbedInfo, {reportId: reportId, entityTypeId:entityTypeId, entityId:entityId });
    }
}